import { render, staticRenderFns } from "./VehicleConfig.vue?vue&type=template&id=1de52407&scoped=true"
import script from "./VehicleConfig.vue?vue&type=script&lang=js"
export * from "./VehicleConfig.vue?vue&type=script&lang=js"
import style0 from "./VehicleConfig.vue?vue&type=style&index=0&id=1de52407&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@1.0.1_vue-template-compiler@2.6.10_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de52407",
  null
  
)

export default component.exports